import { observer } from "mobx-react-lite"

import { SortIcon } from "@/domains/liquidity-page/sort-icon"
import { Sort } from "@/domains/table-processor"

export const DisplaySortIcon = observer(({ sortBy, column }: { sortBy: Sort; column: string }) => {
  if (!(column === sortBy.key)) {
    return null
  }
  return <SortIcon direction={sortBy.direction} />
})
